import star from "../images/star.png";
import automatization from "../images/Avtomatizacija.png";
import regionalNetwork from "../images/Regionalna mrezha.png";
import modernSystem from "../images/Moderen sistem.png";
import easyIntegration from "../images/Lesna integracija.png";
import connected from "../images/Povrzan so drzhavnite sistemi.png";
import support from "../images/Tehnichka poddrshka.png";

const MerakzyAdvantagesSection = () => {
  return (
      <section className="bg-white pb-24 py-12 md:py-24">
        <div className="container mx-auto">
          <div className="text-left md:text-center mb-12">
            <div className="flex items-center md:justify-center gap-2 mb-6">
              <div className="w-6 h-6 flex items-center justify-center rounded-full">
                <img src={star} alt="" className="w-6 h-6" />
              </div>
              <span className="font-semibold text-sm">ПРЕДНОСТИ НА MERAKZY</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-semibold mb-6">
              Зошто Merakzy е најдобриот, современ  <br /> софтвер за туристичко работење?
            </h2>

            <p className="text-lg md:text-xl text-gray-800">
              Заборавете на старите навики и рачната работа. Merakzy ги решава основните <br />
              предизвици во секојдневното работење и ви нуди систем што оди чекор понатаму.
            </p>
          </div>
 
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: automatization, title: "Автоматизација без хаос", description: "Сите резервации, уплати и агенти на едно место. Без двојно внесување податоци и рачна проверка. ",  bgColor: "bg-gradient-to-r from-[#FA0053] to-[#B6003C]", iconBg: "bg-white", textColor: "text-white" },
              { icon: regionalNetwork, title: "Регионална мрежа на субагенти", description: "Лесно споделување понуди со субагенти и одобрување резервации без повици и мејлови.", bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
              { icon: modernSystem, title: "Модерен систем како Booking.com", description: "Логичен, интуитивен и едноставен за користење, a се развива заедно со потребите на агенциите.", bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
              { icon: easyIntegration, title: "Лесна интеграција со веб-страници", description: "Merakzy има свое API за брза интеграција со нови и  постоечки веб-страници за онлајн плаќање.", bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
              { icon: connected, title: "Поврзан со државните системи", description: "Усогласен е со законски прописи и системи во Македонија и Србија.",bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
              { icon: support, title: "Техничка поддршка 24/7", description: "Брза поддршка за реални ситуации во секојдневната работа, без чекање и губење време.", bgColor: "border border-gray-200", iconBg: "bg-[#fa0053]", textColor: "text-black" },
            ].map((card, i) => (
              <div key={i} className={`p-6 rounded-[40px] flex flex-col gap-4 ${card.bgColor}`}>
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${card.iconBg}`}>
                  <img src={card.icon} alt="" className="w-6 h-6" />
                </div>
                <h3 className={`font-semibold ${card.textColor} text-xl`}>{card.title}</h3>
                <p className={`${card.textColor} text-base`}>{card.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
  );
};

export default MerakzyAdvantagesSection;